import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../shared/services/app-config.service';
import { CrazyCallConfigService } from '../shared/services/crazycall-config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../shared/services/app-config.service";
import * as i3 from "../shared/services/crazycall-config.service";
var GlobalSettingsService = /** @class */ (function () {
    function GlobalSettingsService(http, appConfigService, crazyCallConfigService) {
        this.http = http;
        this.appConfigService = appConfigService;
        this.crazyCallConfigService = crazyCallConfigService;
    }
    GlobalSettingsService.prototype.getGlobalSettings = function () {
        return this.http.get("" + this.appConfigService.WEB_CALL_BACKEND_CONFIGURATOR_URL + this.crazyCallConfigService.appId + "/global-settings");
    };
    GlobalSettingsService.prototype.updateGlobalSettings = function (data) {
        return this.http.put("" + this.appConfigService.WEB_CALL_BACKEND_CONFIGURATOR_URL + this.crazyCallConfigService.appId + "/global-settings", data);
    };
    GlobalSettingsService.ngInjectableDef = i0.defineInjectable({ factory: function GlobalSettingsService_Factory() { return new GlobalSettingsService(i0.inject(i1.HttpClient), i0.inject(i2.AppConfigService), i0.inject(i3.CrazyCallConfigService)); }, token: GlobalSettingsService, providedIn: "root" });
    return GlobalSettingsService;
}());
export { GlobalSettingsService };
